const setSpouseNationality = (id = null) => {
  return {
    type: 'SET_SPOUSENATIONALITY',
    id
  }
}

export default {
  setSpouseNationality,
}
